import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin: -24px 0 0 0;\n  height: 64px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect } from 'react';
import styled from 'styled-components';
import { DisplayMedium } from '../../typography';
import useModalContext from '../utils/useModalContext';
var ModalTitle = styled(function (props) {
  var _useModalContext = useModalContext(),
      id = _useModalContext.id,
      registerTitle = _useModalContext.registerTitle;

  useEffect(function () {
    registerTitle(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(DisplayMedium, _extends({}, props, {
    id: "dialog-title-".concat(id)
  }));
})(_templateObject());
export default ModalTitle;